import { useEffect, useState } from "react";
import BriefingTable from "components/Briefing/subcomponents/table";

import { useSelector } from "react-redux";
import Actions from "components/Briefing/subcomponents/actions"; // Fixed typo (Actoins -> Actions)
import { briefingTrucksAPI } from "components/Apis/Briefing"; // Changed to use truck API
import { TextField } from "components/Briefing/subcomponents/safety-subcomponents/fields";
import HistoryViewer from "components/Briefing/subcomponents/safety-subcomponents/historyViewer";
import toast from "react-hot-toast";

const TruckReports = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const currentTerminal = useSelector((state) => state.terminals.currentTerminal);
    const briefing = useSelector((state) => state.briefing.line);
    const archived = (briefing === "Old Briefings");

    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            if (archived) {
                const requestPayload = {
                    "startDate": startDate,
                    "endDate": endDate,
                    "searchTerm": searchTerm
                }
                const response = await briefingTrucksAPI.getArchive(requestPayload); // Changed to truck API
                setData(response.data);
            }
            else {
                const response = await briefingTrucksAPI.filter({
                    archived: false,
                    terminal: currentTerminal ? currentTerminal.id : 'None',
                    search_term: searchTerm
                });
                setData(response.data);
            }
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing, currentTerminal]);

    const headers = [
        "ID",
        "Truck", // Changed to "Truck"
        "Location",
        "Notes",
        'Act.'
    ];

    const renderRow = (row) => (
        <>
            <tr key={`safety-truck-row-${row.id}`} className="safety-row">
                <td className="row-id-cell">
                    <div className="row-id-div">
                        {row.id}
                    </div>
                </td>
                <td style={{ width: "15%" }}>
                    <TextField row={row} label={"truck"} onBackendSync={briefingTrucksAPI.update} /> {/* Changed to "truck" */}
                </td>
                <td style={{ width: "15%" }}>
                    <TextField row={row} label={"location"} maxLength={50} onBackendSync={briefingTrucksAPI.update} />
                </td>
                <td>
                    <TextField row={row} label={"notes"} maxLength={500} onBackendSync={briefingTrucksAPI.update} />
                </td>
                <td className="actions-cell">
                    <Actions
                        onDelete={() => (
                            briefingTrucksAPI.delete(row.id).then(() => { // Changed to truck API
                                setRefresh(!refresh);
                            }).catch((error) => {
                                console.error("Error deleting truck:", error); // Changed to "truck"
                                toast.error(error.response?.data?.msg || "An error occurred while deleting the truck."); // Changed to "truck"
                            })
                        )}
                        onArchive={() => (
                            briefingTrucksAPI.update(row.id, { archived: true }).then(() => { // Changed to truck API
                                setRefresh(!refresh);
                            })
                        )}
                    />
                </td>
            </tr>
            <tr>
                <td colSpan={headers.length - 1} className="pt-0 pb-1">
                    <span className="input-updated-at-label">
                        Updated by: {row.updated_by ? row.updated_by : "Unknown"} {row.updated_at ? row.updated_at : "Never"}
                    </span>
                </td>
            </tr>
        </>
    );

    if (archived && !data.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Trucks out of service
                </h2>
                <HistoryViewer
                    historyAPICall={briefingTrucksAPI.getHistory}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={async () => {
                    await briefingTrucksAPI.create({
                        terminal: currentTerminal?.id
                    })
                    setRefresh(!refresh);
                }}
            />
        </>
    );
};

export default TruckReports; // Changed component name to "TruckReports"
